<template>
  <div>
    <div class="response-alert">

    <div class="alert  alert-success text-success  border bg-white alert-dismissible" v-for="m in msg">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <strong></strong>
      {{m}}
    </div>

      <div class="alert  alert-danger text-danger  border bg-white alert-dismissible" v-for="error in errors">
        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <strong></strong>
        {{error}}
      </div>

    </div>
    <photo-nav :toDate="toDate" :fromDate="fromDate" ></photo-nav>
    <SideNav :searchString="searchString" :photosUpdate="photosUpdate"></SideNav>
    <div id="main" class="skybackground pl-2 pl-xl-3 pr-0" :style="{marginLeft:margin}">

      <Main :searchString="searchString" :toDate="toDate" :fromDate="fromDate"/>

      <Details v-if="isDetailView"/>

      <WithMap/>

      <BottomNav/>

    </div>
    <photo-modal/>
    <SelectionModal :selectedPhots = "selectedPhots"></SelectionModal>
    <HerunteriadenModal :selectedPhots = "selectedPhots"></HerunteriadenModal>
    <EmailModal :selectedPhots = "selectedPhots"></EmailModal>
    <XXLPhotoModal :photoIDCollection='photosgloab' ref="xxlmodal"></XXLPhotoModal>

    <div class="modal fade planFlagModal"
         id="planFlagModal"
         tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style="height:calc(100vh - 50px); top: 5vh;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header w-100">
            <h5 class="modal-title">Vorschau</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body planflagbody" style="flex-direction: column; align-items: center;">
            <div class="row" v-if="planmodal" style="height:100%;">
              <div class="col-sm-6 text-center">
                <div style="width:100%; position: relative; max-height:100%; height: 100%;overflow: hidden; background-repeat: no-repeat; background-size: contain; background-position: center center"
                     :style="{'background-image':`url(${planmodal.image.src}`}"
                >
<!--                  <img class="zoomImg" :src="planmodal.image.src" style="object-fit: contain; max-height: 100%; max-width: 100%;" alt="img">-->
                  <div class="footer_detail_block px-0">
                    <ul class="footer_details">
                      <li class="text-center">Nr. {{planmodal.image.runid}}</li>
                      <li>|</li>
                      <li class="text-center">{{planmodal.image.photodateBydot}}</li>
                      <li>|</li>
                      <li class="text-center">{{planmodal.image.photodateBytime}} Uhr</li>
                    </ul>
                  </div>
                </div>

              </div>
              <div class="col-sm-6 text-center" >
                <div class="planblock" style="position: relative; justify-self: center;display: inline-flex;justify-content: space-around;flex-wrap: nowrap;
                ">
                  <img :src="planmodal.plan.src" alt="" style="max-width: 100%; max-height: calc(100vh - 250px);">

                  <template v-for="flag in planmodal.plan.flags" >

                    <div class="flagindetails arrowstart" id="arrowstart"
                         style="position:absolute; background-color: red; border-radius: 100%; width:10px; height:10px; margin-left:-5px; margin-top:-5px;"
                         :style="{left: flag.left, top: flag.top}"
                    ></div>

                    <div class="arrowend" id="arrowend" style="position:absolute; background-color: red; border-radius: 100%; width:1px; height:1px; margin-left:-1px; margin-top:-1px;"
                         :style="{left: flag.aleft, top: flag.atop}">
                    </div>

                  </template>

                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>
import PhotoNav from './components/nav'
import SideNav from './components/SideNav'
import PhotoModal from './components/PhotoModal'
import XXLPhotoModal from  '../projects/PhotoModal'
import BottomNav from './components/BottomNav'
import Details from './components/Details'
import Main from './components/Main'

import SelectionModal from './components/SelectionModal'

import HerunteriadenModal from './components/HerunteriadenModal'
import EmailModal from './components/EmailModal'
import WithMap from './components/WithMap'
import LeaderLine from 'leader-line-new'

export default {
  name: 'photo',
  data () {
    return {
      searchString: '',
      photosUpdate: '',
      toDate: '',
      fromDate: '',
      photos: [],
      selectedPhots: [],
      msg: [],
      errors: [],
      sliderImages: [],
      allPhotos: []
    }
  },
  components: {
    WithMap,
    EmailModal,
    HerunteriadenModal,
    SelectionModal,
    Main,
    Details,
    BottomNav,
    SideNav,
    PhotoNav,
    PhotoModal,
    XXLPhotoModal
  },
  computed: {
    isDetailView () {
      return this.$store.state.photo.isDetailView
    },
    margin () {
      return this.$store.state.photo.opennav.MarginProperty
    },
    photosgloab () {
      return this.$store.state.photo.photos
    },
    planmodal () {

      if( Object.keys(this.$store.state.photo.planmodal).length === 0) {
        return false
      }

      let line

      console.log('PlanModal Content', this.$store.state.photo.planmodal)

      $('.planFlagModal').on('shown.bs.modal', function () {
        setTimeout(function() {
          line = new LeaderLine(
            document.getElementById('arrowstart'),
            document.getElementById('arrowend'),
            {color: 'red', size: 6, path: 'straight'}
          )
          document.querySelector('.leader-line').style.zIndex = 110000;

          // window.onscroll = function() {
          //   line.position()
          //   console.log('Scroll Tick!')
          // };
          //
          // document.addEventListener('scroll', function(e) {
          //   line.position()
          //   console.log('Scroll Tick!')
          // })


        }, 500);

      })



      $('.planFlagModal').on('hide.bs.modal', function () {
        line.remove()
      })


      return this.$store.state.photo.planmodal
    }

  },
  mounted () {

  },
  methods: {
    loadXXL(photo) {
      this.$refs.xxlmodal.loadxxl(photo)
    },
  }
}
</script>
<style scoped>
  .active{
    background-color: #39F !important;
    color: #ffffff !important;
  }

  #planFlagModal .modal-dialog {
    width: 90vw;
    height: 90vh;
    max-width: 90vw;
    max-height: 90vh;
    margin: auto;
  }

  #planFlagModal .modal-content {
    height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/photo/index.vue